// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"section-title_sectionTitle__tcILT"};